export class AppSettings {
	clientName: string;

	copyright: {
		notice: string;
		year: string;
	};

	domainPrefix: string;
	IdleTimeout: number;
	HapBaseUrl: string;
	IDSApiBaseUrl: string;
	webApiServer: string;
	webApiPort: string;
	idsBaseHref: string;
	GATrackingBaseUrl: string;
	GATrackingId: string;
	WorkforceIdleTimeout:number;
	SessionResetModalShowInSec:number;
	IsSessionTimeoutEnable:boolean;
}
